import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedCity: null,
  selectedStreet: null,
  selectedHouse: null,
  tariff: null,
  formFieldsValues: [],
  name: '',
  surname: '',
  mobile: '',
  email: '',
};

const fiber = createSlice({
  name: 'fiber',
  initialState,
  reducers: {
    setCity: (state, action) => {
      state.selectedCity = action.payload;
    },
    setStreet: (state, action) => {
      state.selectedStreet = action.payload;
    },
    setHouse: (state, action) => {
      state.selectedHouse = action.payload;
    },
    setTariff: (state, action) => {
      state.tariff = action.payload;
    },
    setFormFieldsValues: (state, action) => {
      state.formFieldsValues = action.payload;
    },
    setName: (state, action) => {
      state.name = action.payload;
    },
    setSurname: (state, action) => {
      state.surname = action.payload;
    },
    setMobile: (state, action) => {
      state.mobile = action.payload;
    },
    setEmail: (state, action) => {
      state.email = action.payload;
    },
  },
});

export const { actions } = fiber;

export default fiber.reducer;
